import styled from 'styled-components';
import { Icon } from '@appcues/sonar';
import Link, { LinkProps } from 'studio5/components/Link';

const IconLink = styled(Link).attrs({
  children: <Icon icon="chevron-left" />,
})<{ title: string }>`
  display: flex;
  justify-content: center;
  width: var(--spacing-x-large);
  padding-top: var(--spacing-x-small);
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-width: var(--spacing-x-x-x-large);
  position: absolute;
  left: -64px;
`;

export type BacklinkProps = {
  showIcon?: boolean;
} & LinkProps;

const BackLink = ({ href, to, title, showIcon = true }: BacklinkProps) => {
  return (
    <Container>
      {showIcon && <IconLink href={href} to={to} title={title} />}
    </Container>
  );
};

export default styled(BackLink)``;
